<script>
import { mapGetters } from 'vuex';
import ClearSelectionButton from './ClearSelectionButton.vue';
import { CSAT_RATINGS } from 'shared/constants/messages';

// Filtro de nota POR ESCALA: as opções saem das escalas do período
// (Csat::ScoreSummary.by_scale, que o backend calcula sem o filtro de nota —
// senão escolher uma nota apagaria as outras opções). Um 5 de 1 a 5 e um 5 de
// 1 a 10 são opções diferentes; antes o filtro era só "5" e somava os dois.
export default {
  name: 'ReportFiltersRatings',
  components: { ClearSelectionButton },
  emits: ['ratingFilterSelection'],
  data() {
    return {
      selectedOption: null,
    };
  },
  computed: {
    ...mapGetters({
      metrics: 'csat/getMetrics',
    }),
    scales() {
      return this.metrics.scales || [];
    },
    // Agrupado por escala (group-values do multiselect). Escala de 1 a 5 usa
    // as carinhas de sempre; as outras, "8/10".
    groups() {
      return this.scales.map(scale => ({
        title: this.$t('CSAT_REPORTS.METRIC.SCALE_ROW.TITLE', {
          scale: scale.scale_label,
        }),
        options: this.optionsFor(scale),
      }));
    },
  },
  methods: {
    optionsFor({ scale_min: min, scale_max: max }) {
      const isDefault = min === 1 && max === 5;
      return Array.from(
        { length: max - min + 1 },
        (_value, offset) => max - offset
      ).map(value => {
        const rating = isDefault
          ? CSAT_RATINGS.find(item => item.value === value)
          : null;
        return {
          key: `${min}-${max}:${value}`,
          value,
          scaleMin: min,
          scaleMax: max,
          label: rating ? this.$t(rating.translationKey) : `${value}/${max}`,
        };
      });
    },
    clearSelection() {
      this.selectedOption = null;
      this.handleInput(null);
    },
    handleInput(selectedRating) {
      this.$emit('ratingFilterSelection', selectedRating);
    },
  },
};
</script>

<template>
  <div class="multiselect-wrap--small">
    <multiselect
      v-model="selectedOption"
      class="no-margin"
      :option-height="24"
      :placeholder="$t('FORMS.MULTISELECT.SELECT_ONE')"
      :options="groups"
      group-values="options"
      group-label="title"
      :group-select="false"
      :show-labels="false"
      track-by="key"
      label="label"
      @update:model-value="handleInput"
    >
      <template #clear>
        <ClearSelectionButton v-if="selectedOption" @clear="clearSelection" />
      </template>
    </multiselect>
  </div>
</template>
